import { generateUtilityClass, generateUtilityClasses } from '@mui/base';

export function getStepIconUtilityClass(slot: string) {
  return generateUtilityClass('O2StepIcon', slot);
}

const stepIconClasses = generateUtilityClasses('O2StepIcon', [
  'root',
  'active',
  'completed',
  'error',
  'text',
  'icon',
  'checkmark',
  'dot',
]);

export default stepIconClasses;
